export const colors = [
  { bgColor: "bg-yellow-200", textColor: "text-yellow-600" },
  { bgColor: "bg-blue-200", textColor: "text-blue-600" },
  { bgColor: "bg-purple-200", textColor: "text-purple-600" },
  { bgColor: "bg-orange-200", textColor: "text-orange-600" },
  { bgColor: "bg-teal-200", textColor: "text-teal-600" },
  { bgColor: "bg-red-200", textColor: "text-red-600" },
  { bgColor: "bg-green-200", textColor: "text-green-600" },
  { bgColor: "bg-pink-200", textColor: "text-pink-600" },
  { bgColor: "bg-indigo-200", textColor: "text-indigo-600" },
];
